import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3485b288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_3 = { class: "bar" }
const _hoisted_4 = { class: "desktop-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "navigation-button title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('/')))
      }, "Pinsetur"),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "navigation-button item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('/trips/past')))
            }, "Tidligere ture"))
          : _createCommentVNode("", true),
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "navigation-button item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('/trips/future')))
            }, "Kommende ture"))
          : _createCommentVNode("", true),
        (_ctx.adminAccess)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "navigation-button item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('/admin')))
            }, "Admin"))
          : _createCommentVNode("", true),
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "navigation-button logout",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
            }, "Log ud"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["burger", { open: _ctx.menuOpen }]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen)),
        "aria-label": "Menu"
      }, _hoisted_8, 2)
    ]),
    (_ctx.menuOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mobile-menu",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.menuOpen = false))
        }, [
          (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "mobile-item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate('/trips/past')))
              }, "Tidligere ture"))
            : _createCommentVNode("", true),
          (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "mobile-item",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate('/trips/future')))
              }, "Kommende ture"))
            : _createCommentVNode("", true),
          (_ctx.adminAccess)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "mobile-item",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigate('/admin')))
              }, "Admin"))
            : _createCommentVNode("", true),
          (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "mobile-item",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
              }, "Log ud"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}